import React from 'react'
import '../stylesheets/Skillbars.scss'

const Skillbars = () => {

  const skills = [
    {
      type: 'HTML',
      score: '80%'
    },
    {
      type: 'CSS',
      score: '70%'
    },
    {
      type: 'Javascript',
      score: '85%'
    },
    {
      type: 'React.js',
      score: '90%'
    },
    {
      type: 'Redux & Saga',
      score: '70%'
    },
    {
      type: 'Gatsby.js',
      score: '80%'
    },
    {
      type: 'Ruby & Rails',
      score: '50%'
    },
    {
      type: 'Node.js',
      score: '55%'
    },
    {
      type: 'Git',
      score: '80%'
    },
    {
      type: 'GraphQL',
      score: '55%'
    },
  ]

  const skillsList = skills.map(skill => {
    return (
      <li>
        <div className="bar-flex">
          <div className="chart__bar" style={{ width: `${skill.score}` }}></div>
          <span className="chart__label">
            {skill.type}
          </span>
          <div className="score">{skill.score}</div>
        </div>
      </li>
    )
  })

  return (
    <div className="flexbox">
      <div className="skillbars">
        <div className="charts">
          <div className="chart chart--dev">
            <ul className="chart--horiz">
              {skillsList}
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Skillbars
